import React, {PropTypes, Component} from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import {displayDateFormat} from 'app/lib/format';
import Widget from '../../Widget';
import Preloader from 'routes/app/components/Preloader';
import Gauge from './Gauge';

const rawDataToChartData = (raw) => {
    let config = {percent: 0, numSections: 5};

    if (raw) {
        config.percent = raw.actualLeadTime / 100;
        config.numSections = raw.refValues.length + 1;
    }

    return config;
};

class ActualLeadTime extends Component {

    static propTypes = {
        rawData: PropTypes.object.isRequired,
        intl: PropTypes.object,
        fetch: PropTypes.func.isRequired,
        values: PropTypes.shape({
            dom: PropTypes.string
        })
    };

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.values.dom !== nextProps.values.dom) {
            this.fetchData(nextProps.values.dom);
        }
    }

    fetchData = (dom) => {
        dom = dom || this.props.values.dom;
        this.props.fetch({dom});
    };

    render() {
        const {rawData, intl:{formatMessage}} = this.props;

        return (
            <Widget
                onRefresh={this.fetchData}
                title={
                     <FormattedMessage id="dashboard.actualLeadTime.title"
                      values={{date:moment().format(displayDateFormat)}} />}>

                {rawData.isLoading ?
                    <Preloader />
                    :
                    rawData.isError ?
                        <FormattedMessage id="dashboard.actualLeadTime.fetchError" />
                        :
                        Object.keys(rawData).length === 0 ?
                            <FormattedMessage id="dashboard.actualLeadTime.empty" />
                            :
                            <Gauge {...rawDataToChartData(rawData)} />
                }
            </Widget>
        );
    }
}

export default ActualLeadTime;